import useIsActive from '../../../hooks/useIsActive'
import ThumbnailLead from '../../articleList/thumbnailLead.component'
import ThumbnailTitle from '../../articleList/thumbnailTitle.component'
import ImageItem from '../../article/imageItem.component'
import { IArticleHead } from '../../../interfaces/article'
import { urlObjectFactoryForPagesWithSlug } from '../../../utils/webmenus'
import { useAppContext } from '../../../context/siteMapContext'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { serverForImages } from '../../../config'

interface IFeaturedNewsProps {
  articleHead: IArticleHead
  activeItemId: string
  prev: any,
  next: any,
}

const FeaturedNewsThumbnail: React.FC<IFeaturedNewsProps> = ({
  articleHead,
  activeItemId,
  prev,
  next
}) => {
  const { title, coverImage, lead, slug } = articleHead
  const { webmenus } = useAppContext()
  const webmenu = webmenus[articleHead.heading]
  const { pathname } = useRouter();

  const isActive = useIsActive(slug, activeItemId)
  const { urlObject, asPath } = urlObjectFactoryForPagesWithSlug(
    '/article',
    articleHead,
    webmenu
  )

  return (
    <Link href={urlObject} as={asPath} shallow>
      <a>
        <div
          className='flex flex-col transition-all ease-in-out delay-150 h-full'
          style={{
            visibility: isActive ? 'visible' : 'hidden',
            display: isActive ? 'block' : 'none',
          }}
        >
          <div className='border-l-2 border-top-news-title-divider pl-[16px] mb-8 xl:mb-12'>
            <ThumbnailTitle title={title} />
          </div>
          <ImageItem url={coverImage.fileThumbUrl} title={coverImage.title} />
          <div className='flex flex-col xl:flex-row-reverse xl:mx-[-39%]'>
            <div className='hidden z-1 w-full xl:w-[80%] xl:px-[2rem] xl:flex flex-col gap-8 pb-8 justify-center align-middle select-none text-[70px] cursor-pointer text-white text-center' onClick={next} title="Következő" >{'>>>'}</div>
            {!!coverImage && (
              <div className='pb-2 xl:pl-2 xl:pb-0 h-[calc((100vw)/16*9)] xl:h-auto w-full '>
                <figure className='h-full'>
                  <picture
                    key={coverImage.fileThumbUrl}
                    className='overflow-hidden flex relative h-full w-full'
                  >
                    <source srcSet={`${serverForImages}${coverImage.fileThumbUrl}`} type='image/webp' />
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img
                      className={`h-full w-auto m-auto object-contain object-top`}
                      src={`${serverForImages}${coverImage.fileThumbUrl}`}
                      alt={coverImage.title}
                      title={coverImage.title}
                    />
                  </picture>
                </figure>
              </div>
            )}
            <div className='w-full flex text-featured-news xl:text-featured-news-xl xl:pr-2 pb-[12px]'>
              <div
                className='flex flex-col justify-center'
                dangerouslySetInnerHTML={{ __html: lead }}
              />            </div>
            <div className='hidden z-1 w-full xl:w-[80%] xl:px-[2rem] xl:flex flex-col gap-8 pb-8 justify-center align-middle select-none text-[70px] cursor-pointer text-white text-center' onClick={prev} title="Előző">{'<<<'}</div>

          </div>

        </div>
      </a>
    </Link>
  )
}

export default FeaturedNewsThumbnail
